<template>
  <Modal title="取消课程" v-model="visible">
    <Form ref="dataForm" class="form"
          :model="formData" :rules="rule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="取消课程原因：" prop="reason">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                 placeholder="长度不要超过100个字符"
                 v-model="formData.reason" ></Input>
        </Form-item>
        </Col>
        <Col :span="11" v-if="lsnType === 2 && tchChannel === 1">
          <Form-item label="补课时间">
            <Row>
              <Date-picker v-model="formData.makeUpTime" format="yyyy-MM-dd HH:mm" :clearable="true" type="datetime"
                           placement="bottom-start" placeholder="补课时间必填"/>
            </Row>
          </Form-item>
        </Col>
        <Col :span="22" v-if="lsnType === 2 && tchChannel === 1 ">
          <Form-item label="上传截图" prop="attachment">
            <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="formData.attachment" on-file-change="onFileChange"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="onTchLeave">确定</Button>
    </div>
  </Modal>
</template>
<script>
import moment from 'moment'
  export default {
    name: 'LessonCancelModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      lsnType: {
        type: Number
      },
      tchChannel: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        defaultPicList: [],
        visible: this.value,
        formData: {
          reason: '',
          attachment: '',
          makeUpTime: '',
        },
        loadingAdd: false,
        rule: {
          reason: [
            { type: 'string', required: true, message: '请填写取消课程原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      onFileChange (fileList) {
        this.defaultPicList = fileList
      },
      onTchLeave () {
        let self = this
        self.loadingAdd = true
        self.$refs.dataForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.formData.openedId = self.openedId
          if (self.lsnType === 2 && self.tchChannel === 1) {
            self.formData.makeUpTime = moment(self.formData.makeUpTime).format('YYYY-MM-DD HH:mm:ss')
          } else {
            self.formData.makeUpTime = ''
          }
          self.$http.post('/bookLesson/cancelLesson', self.formData).then(function (res) {
            self.loadingAdd = false
            if (res) {
              self.$Message.success('课程取消成功!')
              self.visible = false
              self.successCallback()
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.formData.reason = ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonCancelModal.vue?1b65419a